import React, { Fragment } from 'react';
import IntlMessages from 'util/IntlMessages';
import ProjectIssueDetailRow from '../projectIssueDetailRow';

const ProjectIssueDetailTable = ({ displayData }) => {
    if (displayData) {
        return (
            <table className="default-table table table-sm table-responsive-sm table-hover">
                <tbody>
                    <ProjectIssueDetailRow label={<IntlMessages id="label.priority" />} description={displayData?.priority} />
                    <ProjectIssueDetailRow label={<IntlMessages id="label.status" />} description={displayData?.status} />
                    <ProjectIssueDetailRow label={<IntlMessages id="label.progress.total" />} description={`${displayData?.progress}/ ${displayData?.progressTotal}`} />
                    <ProjectIssueDetailRow label={<IntlMessages id="label.createdDate" />} description={displayData?.created} />
                    <ProjectIssueDetailRow label={<IntlMessages id="label.resolutionDate" />} description={displayData?.resolutionDate} />
                    {displayData?.resolution ?
                        <Fragment>
                            <ProjectIssueDetailRow label={<IntlMessages id="label.resolution.type" />} description={displayData?.resolutionType} />
                            <ProjectIssueDetailRow label={<IntlMessages id="label.resolution.description" />} description={displayData?.resolutionDescription} />
                        </Fragment>
                        : null
                    }
                    {displayData?.subtasks ?
                        <ProjectIssueDetailRow label={<IntlMessages id="label.sub.tasks" />} description={displayData?.subtasks} />
                        : null
                    }
                </tbody>
            </table>
        );
    } else {
        return <Fragment></Fragment>;
    }
};

export default ProjectIssueDetailTable;


// WEBPACK FOOTER //
// ./components/Agile/projectIssue/projectIssueDetail/projectIssueDetailTable/index.js